import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

/** Bölgeye atanmış il: plaka kodu (1-81) + resmi ad */
export interface IRegionProvince {
  code: number;
  name: string;
}

export class IRegionDetailListItem {
  id: number;
  name: string;
  details: string;
  isActive: number;
  datetime: string;
  routeId: string | number;
  /** Bölge açık adresi (sitede herkese açık) — eski kayıtta null */
  address: string | null;
  /** Harita konum linki (https, izinli alan adı) — eski kayıtta null */
  mapUrl: string | null;
  /** Ada göre sıralı atanmış iller; eski API sürümünde gelmeyebilir */
  cities?: IRegionProvince[];
}

export class IRegionDetailResponse {
  @Type(() => IRegionDetailListItem)
  result: IRegionDetailListItem;
}

export class IRegionDetailListResponse extends IPagination {
  @Type(() => IRegionDetailListItem)
  results: IRegionDetailListItem[];
}

export class IRegionDetailPostDto {
  name: string;
  details: string;
  isActive: number;
  datetime: string;
  routeId: number | null;
  address?: string | null;
  mapUrl?: string | null;
  /** Plaka kodları (1-81) */
  cityCodes?: number[];
}

export class IRegionDetailQueryDto extends IQueryPaginationDto {
  name?: string;
  id?: string;
  isActive?: number;
  /** Bu ili kapsayan bölgeler (plaka kodu) */
  cityCode?: number | string;
}

export class IPatchRegionDetailBodyDto {
  name?: string;
  details?: string;
  isActive?: number;
  datetime?: string;
  routeId?: number | null;
  /** null / '' adresi temizler */
  address?: string | null;
  /** null / '' linki temizler */
  mapUrl?: string | null;
  /** Verilirse il kümesi TAMAMEN bununla değişir; [] tümünü kaldırır */
  cityCodes?: number[];
}

export interface IProvinceCoverageRegion {
  id: number;
  name: string;
  isActive: number;
}

export interface IProvinceCoverageRow extends IRegionProvince {
  regions: IProvinceCoverageRegion[];
}

/** GET regionDetail/province-coverage */
export interface IProvinceCoverageResponse {
  result: {
    /** 81 ilin tamamı (ada göre) + atandığı bölgeler (aktif + pasif) */
    provinces: IProvinceCoverageRow[];
    /** Aktif bölgesi olmayan iller */
    unassigned: IRegionProvince[];
    /** 2+ aktif bölgedeki iller (izinli, uyarı) */
    overlaps: (IRegionProvince & { regions: IProvinceCoverageRegion[] })[];
  };
}
